export default "__VITE_ASSET__7wBmfpBO__"